/**
 * Hero-video
 *
 * Två saker:
 *  1. Väljer rätt videofil för viewporten. <video> stödjer inte
 *     media-attributet på <source> i praktiken (Chrome och Firefox
 *     ignorerar det), så källorna skickas som data-attribut från PHP och
 *     väljs här istället.
 *  2. Startar/stoppar originalvideon i "Se videon"-modalen. modal.js
 *     togglar bara klassen `active`, så vi lyssnar på den.
 */

// Måste matcha --breakpoint-* i src/css/theme.css.
const BREAKPOINTS = [
    { key: 'base', min: 0 },
    { key: 'sm', min: 640 },
    { key: 'md', min: 768 },
    { key: 'lg', min: 1024 },
    { key: 'xl', min: 1280 },
]

const RESIZE_DEBOUNCE = 200

/**
 * Närmast större fil först (bättre kvalitet), sedan originalet, sist
 * närmast mindre. Alla brytpunkter är valfria i admin.
 */
function pickSource(video) {
    const width = window.innerWidth

    let current = 0
    BREAKPOINTS.forEach((bp, i) => {
        if (width >= bp.min) current = i
    })

    for (let i = current; i < BREAKPOINTS.length; i++) {
        const src = video.getAttribute(`data-src-${BREAKPOINTS[i].key}`)
        if (src) return src
    }

    const original = video.getAttribute('data-src-original')
    if (original) return original

    for (let i = current - 1; i >= 0; i--) {
        const src = video.getAttribute(`data-src-${BREAKPOINTS[i].key}`)
        if (src) return src
    }

    return ''
}

function applySource(video) {
    const src = pickSource(video)

    if (!src || video.dataset.currentSrc === src) return

    const time = video.currentTime
    const shouldPlay = video.autoplay || !video.paused

    video.dataset.currentSrc = src
    video.src = src
    video.load()

    if (time > 0) {
        // Behåll uppspelningsläget vid byte, t.ex. när en laptop dockas
        // mot en extern skärm.
        video.addEventListener(
            'loadedmetadata',
            () => {
                if (time < video.duration) video.currentTime = time
            },
            { once: true }
        )
    }

    // preload="none" i markup gör att inget hämtas förrän vi ber om det,
    // så uppspelningen måste startas explicit — vi kan inte vänta på
    // loadedmetadata eftersom den då aldrig hinner triggas.
    if (shouldPlay) video.play().catch(() => {})
}

function initResponsiveVideos() {
    const videos = document.querySelectorAll('[data-hero-video]')
    if (!videos.length) return

    videos.forEach((video) => {
        video.dataset.currentSrc = video.getAttribute('src') || ''
        applySource(video)
    })

    let timer
    window.addEventListener('resize', () => {
        clearTimeout(timer)
        timer = setTimeout(() => videos.forEach(applySource), RESIZE_DEBOUNCE)
    })
}

function initModals() {
    const modals = document.querySelectorAll('.hero-video-modal')
    if (!modals.length) return

    modals.forEach((modal) => {
        const modalVideo = modal.querySelector('[data-hero-modal-video]')
        if (!modalVideo) return

        const bgVideo = modal.closest('section')?.querySelector('video.hero-bg-img')

        const observer = new MutationObserver(() => {
            if (modal.classList.contains('active')) {
                bgVideo?.pause()
                modalVideo.play().catch(() => {})
            } else {
                modalVideo.pause()
                modalVideo.currentTime = 0
                if (bgVideo?.autoplay) bgVideo.play().catch(() => {})
            }
        })

        observer.observe(modal, { attributes: true, attributeFilter: ['class'] })
    })
}

document.addEventListener('DOMContentLoaded', () => {
    initResponsiveVideos()
    initModals()
})
